@if (show$ | async) {
  @if (config$ | async; as config) {
    <div
      class="badge"
      role="img"
      tabindex="0"
      [attr.aria-label]="label()"
      [matTooltip]="label()"
      [matTooltipDisabled]="!tooltipsEnabled()"
      [matTooltipShowDelay]="500"
      [ngStyle]="{
        'background-color': config.backgroundColour,
        color: config.colour || white,
        width: badgeStyles().width,
        height: badgeStyles().height
      }"
    >
      @if (config.mode === statusIndicatorMode.Icon) {
        <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
      } @else {
        {{ config.character }}
      }
    </div>
  }
}
